var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SvgImage from '@material-ui/icons/Image';
import { getTranslate } from 'react-localize-redux';
/**
 * Create component class
 */
var ImgCoverComponent = /** @class */ (function (_super) {
    __extends(ImgCoverComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function ImgCoverComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            cover: {
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            },
            loding: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100px',
                position: 'relative',
                color: '#cacecd',
                fontWeight: 400
            },
            loadingContent: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            },
            loadingImage: {
                fill: 'aliceblue',
                width: '50px',
                height: '50px'
            }
        };
        /**
         * Will be called on loading image
         *
         * @memberof ImgCoverComponent
         */
        _this.handleLoadImage = function () {
            _this.setState({
                isImageLoaded: true
            });
        };
        // Defaul state
        _this.state = {
            isImageLoaded: false
        };
        // Binding functions to `this`
        _this.handleLoadImage = _this.handleLoadImage.bind(_this);
        return _this;
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    ImgCoverComponent.prototype.render = function () {
        var _a = this.props, fileName = _a.fileName, style = _a.style, translate = _a.translate;
        var isImageLoaded = this.state.isImageLoaded;
        return (React.createElement("div", null,
            React.createElement("div", { style: Object.assign({}, this.styles.cover, {
                    backgroundImage: 'url(' + (fileName || '') + ')',
                    width: this.props.width,
                    height: this.props.height,
                    borderRadius: this.props.borderRadius
                }, style) }, this.props.children),
            React.createElement("div", { style: Object.assign({}, { backgroundColor: 'blue' }, isImageLoaded ? { display: 'none' } : this.styles.loding) },
                React.createElement("div", { style: this.styles.loadingContent },
                    React.createElement(SvgImage, { style: this.styles.loadingImage }),
                    React.createElement("div", null, translate('image.notLoaded')))),
            React.createElement("img", { onLoad: this.handleLoadImage, src: fileName || '', style: { display: 'none' } })));
    };
    ImgCoverComponent.propTypes = {
        /**
         * Use for getting url address from server
         */
        fileName: PropTypes.string,
        /**
         * Image width
         */
        width: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        /**
         * Image height
         */
        height: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        /**
         * Image border radius
         */
        borderRadius: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ])
    };
    return ImgCoverComponent;
}(Component));
export { ImgCoverComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    return {
        translate: getTranslate(state.get('locale'))
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(ImgCoverComponent);



//////////////////
// WEBPACK FOOTER
// ./src/components/imgCover/ImgCoverComponent.tsx
// module id = 1473
// module chunks = 0 1 2 3 5